import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

type RequestorContextKind = 'request' | 'vacationBid'

interface RequestorRouteContextGuardProps {
  children: ReactNode
  kind: RequestorContextKind
}

const hasItems = (value: unknown): value is unknown[] =>
  Array.isArray(value) && value.length > 0

const hasRequestContext = (state: any) =>
  Boolean(
    state?.timeOffRequestId &&
      (hasItems(state?.timeEntries) || hasItems(state?.selectedDates))
  )

const hasVacationBidContext = (state: any) =>
  hasItems(state?.vacationBids)

const RequestorRouteContextGuard = ({
  children,
  kind,
}: RequestorRouteContextGuardProps) => {
  const location = useLocation()
  const state = location.state
  const hasContext =
    kind === 'request'
      ? hasRequestContext(state)
      : hasVacationBidContext(state)

  if (!hasContext) {
    const requestorHome = location.pathname.startsWith('/admin/requestor')
      ? '/admin/requestor'
      : '/requestor'

    return <Navigate to={requestorHome} replace />
  }

  return <>{children}</>
}

export default RequestorRouteContextGuard